module.exports = "/assets/packs/images/b7b79a32c594d5c591955ddb3da82fa9.svg";